/**
 * useListingTableControllers — sort, page, and page-size handlers that clear
 * selection on every navigation change.
 *
 * A7 from listing-abstraction-opportunities.md
 *
 * All three callbacks delegate to the matching useListingQueryState setters
 * and call `clearSelection?.()` when provided. Table-owned listings omit it
 * and reset via `selection.resetKey`.
 */
import { useCallback } from 'react';
export function useListingTableControllers({ setSort, setPageNumber, setPageSize, clearSelection }) {
    const handleSort = useCallback((dataKey, direction) => {
        setSort(direction ? { field: dataKey, direction } : null);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
    }, [setSort, clearSelection]);
    const handlePageChange = useCallback((page) => {
        setPageNumber(page);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
    }, [setPageNumber, clearSelection]);
    const handlePageSizeChange = useCallback((size) => {
        setPageSize(size);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
    }, [setPageSize, clearSelection]);
    return { handleSort, handlePageChange, handlePageSizeChange };
}
